import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select2"]

  connect() {
    this.autoSubmitTargets.forEach(input => {
      input.addEventListener("change", () => this.element.requestSubmit())
    })

    $(this.select2Targets).each((_, elt) => {
      $(elt).on("change", () => this.element.requestSubmit())
    })
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), 500)
  }

  get autoSubmitTargets() {
    // Fields inside a dropdown menu come with their own apply button (see
    // layouts/_dropdown_checkboxes): submitting on every tick would reload the
    // page and close the dropdown before the user is done choosing.
    return [...this.element.querySelectorAll("input, select, textarea")]
      .filter(field => !field.closest(".dropdown-menu"))
  }
}
